import moment from "moment";

export function toCurrency(str) {
    let value = str;
    if (typeof value !== 'number') {
        value = parseFloat(value);
    }
    if (Number.isNaN(value)) {
        value = 0;
    }

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'GBP',
    });
    return formatter.format(value);
}

export function toUpperCase(value) {
    return value.toUpperCase();
}

export function toDateTime(value, format = 'DD/MM/YYYY HH:mm') {
    return moment(value).format(format)
}

export function timeAgo(value) {
    return moment(value).fromNow()
}
